import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import Header from "../../components/Header";
import useApp from "../../store/contexts/AppContext";
import { RoomStyle } from "../Room/RoomStyle";
import UserWebcam from "../Room/UserWebcam";
import WaitForPageLoad from "../../components/WaitForPageLoad";
import WaitingOnAdminInGroup from "../../components/Chats/WaitingOnAdminInGroup/WaitingOnAdminInGroup";
import RoomUserLobby from "../Room/RoomUserLobby";
import RoomTeams from "../Room/RoomTeams";
import SpectatorModeChargeRoomFee from "../Room/SpectatorModeChargeRoomFee";
import ActiveChatInRoom from "../../components/Chats/ActiveChatInRoom";
import { ROUTES } from "../../routes/User/paths";

const useStyles = makeStyles((theme) => RoomStyle(theme));

export default function SpectateRegularMode() {
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();

  const [roomLoading, setRoomLoading] = useState(true);
  const [isCurrentUserMainAdmin, setIsCurrentUserMainAdmin] = useState(false);
  const [waitingOnAdmin, setWaitingOnAdmin] = useState(false);
  const [showRoomTitle, setShowRoomTitle] = useState(true);
  const [showRoomParticipants, setShowRoomParticipants] = useState(true);
  const [showRoomTeams, setShowRoomTeams] = useState(true);
  const [isUserOnSpectatorModeAndNotPaidRoomFee, setIsUserOnSpectatorModeAndNotPaidRoomFee] = useState(false);
  const [roomCallParticipants, setRoomCallParticipants] = useState({});
  const [previewingRoomParticipants, setPreviewingRoomParticipants] = useState([]);
  const [searchedRoomParticipants, setSearchedRoomParticipants] = useState("");
  const [roomModerators, setRoomModerators] = useState([]);
  const [tempRoomData, setTempRoomData] = useState({});
  const [isModeTitleShowing, setIsModeTitleShowing] = useState(true);
  const [activeRoomPanel, setActiveRoomPanel] = useState("chat");

  const {
    appState: { activeChat, dataLoading, userData, accessToken },
    fetchARoomByIdApiCall,
    setCurrentUserRoomToolboxEnability,
    cancelJoinRequest,
  } = useApp();

  useEffect(() => {
    if (!accessToken) {
      history.replace(`${ROUTES.spectateGuest}/${id}`);
    }
  }, [accessToken, history, id]);

  useEffect(() => {
    fetchARoomByIdApiCall(id, true).then(({ status, data }) => {
      if (status === 204) {
        setWaitingOnAdmin(true);
        return;
      }

      if (status === 206) {
        setIsUserOnSpectatorModeAndNotPaidRoomFee(true);
        setTempRoomData(data);
        return;
      }

      setRoomLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (dataLoading === true) {
      setTimeout(() => {
        setRoomLoading(false);
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataLoading]);

  useEffect(() => {
    if (!waitingOnAdmin) return;

    const handleBeforeUnload = () => cancelJoinRequest();
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      cancelJoinRequest();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [waitingOnAdmin]);

  useEffect(() => {
    setTimeout(() => {
      setIsModeTitleShowing(false);
    }, 5000);
  }, []);

  useEffect(() => {
    setPreviewingRoomParticipants(activeChat?.room_participants || []);
  }, [activeChat?.room_participants]);

  useEffect(() => {
    if (Object.keys(userData).length > 0 && previewingRoomParticipants?.length > 0) {
      const isCurrentUserMainAdminResult = previewingRoomParticipants.some((participant) => {
        const participantId = participant?.id;

        if (userData?.id?.toString() === participantId?.toString()) {
          setCurrentUserRoomToolboxEnability(participant?.is_toolbox_banned ? false : true);
        }

        return (
          Number(participant.is_admin) === 1 &&
          userData?.id?.toString() === participantId?.toString()
        );
      });

      setIsCurrentUserMainAdmin(isCurrentUserMainAdminResult);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, previewingRoomParticipants]);

  useEffect(() => {
    const roomModeratorsIsAdminStatus = [1, 2];
    let getRoomModerators =
      previewingRoomParticipants?.filter((participant) =>
        roomModeratorsIsAdminStatus.includes(participant.is_admin)
      ) || [];

    getRoomModerators = getRoomModerators.map((participant) => ({
      id: participant.id,
      username: participant.username,
      is_admin: participant.is_admin,
    }));

    setRoomModerators(getRoomModerators);
  }, [previewingRoomParticipants]);

  const regex = new RegExp(searchedRoomParticipants, "i");
  const filteredRoomParticipantList = previewingRoomParticipants?.filter((row) =>
    regex.test(row.username)
  );

  const roomParticipantListToRender = searchedRoomParticipants
    ? filteredRoomParticipantList
    : previewingRoomParticipants;

  const roomTabOptions = [
    { value: "chat", label: "Live Chat" },
    { value: "lobby", label: "Users/Lobby List" },
    { value: "scores", label: "Scores" },
  ];

  if (isUserOnSpectatorModeAndNotPaidRoomFee) {
    return <SpectatorModeChargeRoomFee roomData={tempRoomData} />;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" }}>
      <Header isCurrentUserMainAdmin={isCurrentUserMainAdmin} />

      {isModeTitleShowing ? (
        <div className={classes.modeNotification} style={{ backgroundColor: "#FFA500" }}>
          You're in spectator regular mode
        </div>
      ) : null}

      {!waitingOnAdmin && (
        <div id="webcamDisplayCanvas" className={classes.container}>
          <UserWebcam
            roomLoading={roomLoading}
            setShowRoomTitle={setShowRoomTitle}
            showRoomTitle={showRoomTitle}
            setShowRoomParticipants={setShowRoomParticipants}
            showRoomParticipants={showRoomParticipants}
            setShowRoomTeams={setShowRoomTeams}
            showRoomTeams={showRoomTeams}
            isCurrentUserMainAdmin={isCurrentUserMainAdmin}
            roomId={id}
            setRoomCallParticipants={setRoomCallParticipants}
            roomCallParticipants={roomCallParticipants}
            isUserOnSpectatorMode={true}
          />
          <div></div>
        </div>
      )}

      <div className={classes.container2}>
        {roomLoading ? (
          <WaitForPageLoad />
        ) : waitingOnAdmin ? (
          <WaitingOnAdminInGroup />
        ) : (
          <div className={classes.roomTabbedPanelWrapper}>
            <div className={classes.roomTabsBar}>
              {roomTabOptions.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  className={`${classes.roomTabButton} ${
                    activeRoomPanel === option.value ? classes.roomTabButtonActive : ""
                  }`}
                  onClick={() => setActiveRoomPanel(option.value)}
                >
                  {option.label}
                </button>
              ))}
              <button
                type="button"
                className={classes.roomTabButton}
                onClick={() => history.push(`${ROUTES.rooms}/${id}`)}
              >
                Join As Participant
              </button>
            </div>

            <div className={classes.roomPanelSurface}>
              {activeRoomPanel === "scores" ? (
                showRoomTeams ? (
                  <RoomTeams />
                ) : (
                  <div className={classes.roomPanelEmptyState}>Scores are currently hidden.</div>
                )
              ) : null}

              {activeRoomPanel === "lobby" ? (
                showRoomParticipants ? (
                  <RoomUserLobby
                    setSearchedRoomParticipants={setSearchedRoomParticipants}
                    roomParticipants={roomParticipantListToRender}
                    roomLoading={roomLoading}
                    roomModerators={roomModerators}
                    roomId={id}
                  />
                ) : (
                  <div id="lobbyButton" className={classes.roomPanelEmptyState}>
                    Users/Lobby list is currently hidden.
                  </div>
                )
              ) : null}

              {activeRoomPanel === "chat" ? (
                <ActiveChatInRoom roomLoading={roomLoading} roomModerators={roomModerators} />
              ) : null}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
